module.exports = __webpack_public_path__ + "static/media/078-padlock.c06b156a.svg";